/* EV-PRODUKT – produktsidans logik: varianter, storleksguide, galleri, helskärm, lägg i varukorg, följande köpknapp. */
(function () {
  var root = document.querySelector('[data-evp]');
  if (!root || root._evp) return; root._evp = 1;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var data; try { data = JSON.parse($('[data-evp-json]').textContent); } catch (e) { return; }
  var form = $('[data-form]'), vid = $('[data-vid]'), addBtn = $('[data-add]'), addT = $('[data-add-t]');
  var opts = $$('.evp-opt');
  function sz(s) { s = String(s || '').toUpperCase().replace(/\s+/g, ''); return ({ XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL' })[s] || s; }
  function restart(el, c) { el.classList.remove(c); void el.offsetWidth; el.classList.add(c); }

  /* ---------- Varianter ---------- */
  var sel = opts.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
  // Om produkten har storlekar och ingen variant valts via URL: låt kunden välja storlek aktivt
  var urlHasVariant = /[?&]variant=/.test(location.search);
  if (data.si > -1 && !urlHasVariant && opts[data.si]) {
    var sizes = opts[data.si].querySelectorAll('input');
    if (sizes.length > 1) { sel[data.si] = null; sizes.forEach(function (i) { i.checked = false; }); }
  }
  function match() {
    if (!opts.length) return data.v[0] || null;   // produkt utan val (en enda variant)
    if (sel.indexOf(null) !== -1) return null;
    for (var i = 0; i < data.v.length; i++) { var v = data.v[i]; if (v.o.every(function (x, j) { return x === sel[j]; })) return v; }
    return null;
  }
  function render(fromUser) {
    opts.forEach(function (f, i) {
      var cur = f.querySelector('[data-cur]'); if (cur) cur.textContent = sel[i] || '';
      if (sel[i] === null) f.setAttribute('data-need', ''); else f.removeAttribute('data-need');
      f.querySelectorAll('input').forEach(function (inp) {
        var ok = data.v.some(function (v) { return v.a && v.o[i] === inp.value && v.o.every(function (x, j) { return j === i || sel[j] === null || x === sel[j]; }); });
        inp.closest('label').classList.toggle('is-na', !ok);
        inp.closest('label').title = ok ? '' : 'Slut i den här kombinationen';
      });
    });
    var v = match();
    $$('.evp-table tbody tr').forEach(function (tr) {
      var real = null, want = sz(tr.dataset.size);
      if (data.si > -1) opts[data.si].querySelectorAll('input').forEach(function (i) { if (sz(i.value) === want) real = i.value; });
      tr.classList.toggle('is-missing', !real); tr.dataset.real = real || '';
      tr.classList.toggle('is-on', !!real && real === sel[data.si]);
    });
    // Pris (lägsta pris bland möjliga varianter när valet inte är klart)
    var cands = data.v.filter(function (x) { return x.o.every(function (o, j) { return sel[j] === null || o === sel[j]; }); });
    var num = function (x) { return parseFloat(String(x.p).replace(/[^0-9,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.')) || 0; };
    var show = v || cands.reduce(function (m, x) { return !m || num(x) < num(m) ? x : m; }, null) || data.v[0];
    var varies = !v && cands.some(function (x) { return x.p !== show.p; });
    var now = $('[data-now]'), was = $('[data-was]');
    var txt = (varies ? 'från ' : '') + show.p;
    if (now.textContent !== txt) { now.textContent = txt; if (fromUser) restart($('[data-price]'), 'evp-flash'); }
    was.hidden = !show.c; if (show.c) was.textContent = show.c;
    $('[data-price]').classList.toggle('is-sale', !!show.c);
    var sp = document.querySelector('[data-sticky-price]'); if (sp) sp.textContent = txt;
    // Lager, artikelnummer, EAN
    var st = $('[data-stock]');
    if (v) {
      var inStock = v.q > 0;
      st.hidden = false;
      st.classList.toggle('is-order', !inStock); st.classList.toggle('is-out', !v.a);
      $('[data-stock-t]').textContent = !v.a ? 'Slut i lager' : (inStock ? 'I lager' : 'Beställningsvara');
      $('[data-stock-d]').textContent = !v.a ? '' : (inStock ? 'Leverans 1–2 dagar' : 'Leverans 3–7 dagar');
      vid.value = v.id;
      var fs = $('[data-fact-sku]'), fe = $('[data-fact-ean]');
      if (fs) { fs.hidden = !v.s; $('[data-sku]').textContent = v.s || ''; }
      if (fe) { fe.hidden = !v.e; $('[data-ean]').textContent = v.e || ''; }
      if (fromUser && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
      if (v.m) goToMedia(v.m);
    } else {
      st.hidden = true;
    }
    updTotal();
    addBtn.disabled = !!(v && !v.a);
    addBtn.classList.toggle('is-wait', !v);
    addT.textContent = !v ? (data.si > -1 && sel[data.si] === null ? 'Välj storlek' : 'Välj variant') : (v.a ? 'Lägg i varukorg' : 'Slut i lager');
    // Färgval utan storlek: visa färgens bild direkt
    if (!v && data.ci > -1 && sel[data.ci] && fromUser) {
      var cv = data.v.find(function (x) { return x.o[data.ci] === sel[data.ci] && x.m; }); if (cv) goToMedia(cv.m);
    }
  }
  opts.forEach(function (f, i) {
    f.addEventListener('change', function (e) {
      if (!e.target.matches('input')) return;
      sel[i] = e.target.value; root.classList.remove('is-hint'); render(true);
    });
  });
  function pickSize(val) {
    if (data.si < 0 || !val) return;
    var inp = Array.prototype.find.call(opts[data.si].querySelectorAll('input'), function (i) { return i.value === val; });
    if (inp) { inp.checked = true; sel[data.si] = val; render(true); }
  }
  root.addEventListener('click', function (e) {
    var tr = e.target.closest('.evp-table tbody tr'); if (tr && tr.dataset.real) pickSize(tr.dataset.real);
    if (e.target.closest('[data-guide-open]')) { var g = $('[data-guide]'); if (g) { g.open = true; g.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
    var q = e.target.closest('[data-q]');
    if (q) { var inp = $('.evp-qty input'); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (+q.dataset.q)); updTotal(); }
  });
  root.addEventListener('keydown', function (e) {
    var tr = e.target.closest && e.target.closest('.evp-table tbody tr');
    if (tr && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pickSize(tr.dataset.real); }
  });

  /* ---------- Tillägg ---------- */
  var adBox = $('[data-addons]'), adList = $('[data-addon-list]'), totEl = $('[data-total]'), addons = [];
  function money(c) { c = Math.round(c); return (c / 100).toLocaleString('sv-SE', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' kr'; }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function imgUrl(u, w) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u.replace(/([?&])width=\d+/, '$1width=' + w) + (/[?&]width=/.test(u) ? '' : (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w); }
  function addonVariant(i) {
    var p = addons[i], s = adList.querySelector('[data-addon-var="' + i + '"]');
    var id = s ? +s.value : p.av[0].id; return p.av.filter(function (x) { return x.id === id; })[0] || p.av[0];
  }
  function addonItems() {
    return $$('.evp-addon.is-on', adList).map(function (li) { return { id: addonVariant(+li.dataset.addon).id, quantity: 1 }; });
  }
  function updTotal() {
    if (!totEl) return;
    var on = $$('.evp-addon.is-on', adList || root);
    if (!on.length) { totEl.hidden = true; return; }
    var v = match(), qty = Math.max(1, parseInt(($('.evp-qty input') || {}).value, 10) || 1);
    var base = v ? v.pc : Math.min.apply(null, data.v.map(function (x) { return x.pc; }));
    var sum = base * qty + on.reduce(function (s2, li) { return s2 + addonVariant(+li.dataset.addon).p; }, 0);
    totEl.hidden = false;
    totEl.innerHTML = '<span>Totalt med ' + on.length + (on.length === 1 ? ' tillägg' : ' tillägg') + '</span><b>' + (v ? '' : 'från ') + money(sum) + '</b>';
  }
  function renderAddons(list, sub) {
    list = (list || []).filter(function (p) { return p.id !== data.pid; }).map(function (p) {
      p.av = (p.v || []).filter(function (x) { return x.a; }); return p;
    }).filter(function (p) { return p.av.length; }).slice(0, 3);
    if (!list.length || !adBox) return false;
    addons = list;
    adList.innerHTML = list.map(function (p, i) {
      var low = Math.min.apply(null, p.av.map(function (x) { return x.p; }));
      var sel = p.av.length > 1 ? '<select class="evp-addon-var" data-addon-var="' + i + '" aria-label="Välj variant för ' + esc(p.t) + '">' +
        p.av.map(function (x) { return '<option value="' + x.id + '">' + esc(x.t) + ' · ' + money(x.p) + '</option>'; }).join('') + '</select>' : '';
      return '<li class="evp-addon" data-addon="' + i + '">' +
        '<a class="evp-addon-img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(imgUrl(p.img, 160)) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</a>' +
        '<div class="evp-addon-t"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a><span>' + (p.av.length > 1 ? 'Från ' : '') + money(low) + '</span>' + sel + '</div>' +
        '<button type="button" class="evp-addon-btn" data-addon-toggle="' + i + '" aria-pressed="false" aria-label="Lägg till ' + esc(p.t) + '"><i aria-hidden="true"></i><span>Lägg till</span></button></li>';
    }).join('');
    if (sub) $('[data-addons-sub]').textContent = sub;
    adBox.hidden = false;
    return true;
  }
  function loadRecs(intent) {
    var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    return fetch(base + 'recommendations/products.json?product_id=' + data.pid + '&limit=6&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).map(function (p) { return { id: p.id, t: p.title, u: p.url, img: p.featured_image, v: (p.variants || []).map(function (x) { return { id: x.id, t: x.title, a: x.available, p: x.price }; }) }; }); })
      .catch(function () { return []; });
  }
  if (adBox) {
    if (!renderAddons(data.x)) {
      var go2 = function () {
        if (!window.fetch) return;
        loadRecs('complementary').then(function (l) { renderAddons(l); });
      };
      ('requestIdleCallback' in window) ? requestIdleCallback(go2, { timeout: 2500 }) : setTimeout(go2, 900);
    }
    adList.addEventListener('click', function (e) {
      var b = e.target.closest('[data-addon-toggle]'); if (!b) return;
      var li = b.closest('.evp-addon'), on = !li.classList.contains('is-on');
      li.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      b.querySelector('span').textContent = on ? 'Tillagd' : 'Lägg till';
      updTotal();
    });
    adList.addEventListener('change', function (e) { if (e.target.matches('select')) updTotal(); });
  }
  var qIn = $('.evp-qty input'); if (qIn) qIn.addEventListener('input', updTotal);

  /* ---------- Lägg i varukorg ---------- */
  form.addEventListener('submit', function (e) {
    var v = match();
    if (!v) {
      e.preventDefault(); restart(root, 'is-hint');
      var need = $('.evp-opt[data-need]'); if (need) need.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!window.fetch) return; // vanlig formulärpost som reserv
    e.preventDefault();
    addBtn.classList.add('is-busy');
    var qty = Math.max(1, parseInt($('.evp-qty input').value, 10) || 1);
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty }].concat(addonItems()) })
    }).then(function (r) {
      addBtn.classList.remove('is-busy');
      if (!r.ok) { addT.textContent = 'Något gick fel – försök igen'; return; }
      addBtn.classList.add('is-done'); addT.textContent = 'Tillagd i varukorgen ✓';
      $$('.evp-addon.is-on', adList || root).forEach(function (li) { li.querySelector('[data-addon-toggle]').click(); });
      try { if (window.theme && theme.miniCart) { theme.miniCart.generateCart(); theme.miniCart.updateElements(); } } catch (err) {}
      setTimeout(function () { addBtn.classList.remove('is-done'); render(false); }, 2200);
    }).catch(function () { addBtn.classList.remove('is-busy'); form.submit(); });
  });

  /* ---------- Galleri ---------- */
  var stage = $('[data-stage]'), slides = $$('.evp-slide'), thumbs = $$('.evp-thumb'), idx = 0;
  function go(i, smooth) {
    if (!slides.length) return;
    idx = (i + slides.length) % slides.length;
    stage.scrollTo({ left: slides[idx].offsetLeft - stage.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    mark();
  }
  function mark() {
    thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === idx); t.setAttribute('aria-selected', j === idx); });
    var th = thumbs[idx]; if (th && th.parentNode.scrollTo) th.parentNode.scrollTo({ left: th.offsetLeft - 40, behavior: 'smooth' });
  }
  function goToMedia(id) { for (var i = 0; i < slides.length; i++) if (+slides[i].dataset.media === +id) { go(i); return; } }
  var st0 = 0;
  stage && stage.addEventListener('scroll', function () {
    clearTimeout(st0); st0 = setTimeout(function () { var i = Math.round(stage.scrollLeft / stage.clientWidth); if (i !== idx) { idx = i; mark(); } }, 80);
  }, { passive: true });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-go]'); if (t) go(+t.dataset.go);
    var s = e.target.closest('[data-step]'); if (s) go(idx + (+s.dataset.step));
  });
  stage && stage.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(idx + 1); if (e.key === 'ArrowLeft') go(idx - 1); });
  mark();

  /* ---------- Helskärm ---------- */
  var lb = $('[data-lb]'), lbImg = $('[data-lb-img]'), lbi = 0, lastF = null;
  function lbShow(i) { lbi = (i + data.imgs.length) % data.imgs.length; lbImg.src = data.imgs[lbi].src; lbImg.alt = ''; }
  function lbOpen(i) { if (!data.imgs.length) return; lastF = document.activeElement; lbShow(i); lb.hidden = false; document.documentElement.style.overflow = 'hidden'; $('[data-lb-close]').focus(); }
  function lbClose() { lb.hidden = true; document.documentElement.style.overflow = ''; if (lastF) lastF.focus(); }
  root.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom]'); if (z) lbOpen(+z.dataset.zoom);
    if (e.target.closest('[data-lb-close]') || e.target === lb) lbClose();
    var s = e.target.closest('[data-lb-step]'); if (s) lbShow(lbi + (+s.dataset.lbStep));
  });
  document.addEventListener('keydown', function (e) {
    if (lb.hidden) return;
    if (e.key === 'Escape') lbClose(); if (e.key === 'ArrowRight') lbShow(lbi + 1); if (e.key === 'ArrowLeft') lbShow(lbi - 1);
  });

  /* ---------- Mobil: följande köpknapp ---------- */
  var sticky = document.querySelector('[data-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(addBtn);
    document.querySelector('[data-sticky-btn]').addEventListener('click', function () {
      if (match()) { form.requestSubmit ? form.requestSubmit() : addBtn.click(); }
      else { var need = $('.evp-opt[data-need]') || form; need.scrollIntoView({ behavior: 'smooth', block: 'center' }); restart(root, 'is-hint'); }
    });
  }

  render(false);
  if (urlHasVariant) { var v0 = match(); if (v0 && v0.m) goToMedia(v0.m); }
})();
